<template>
  <v-dialog v-model="modalActivo" persistent max-width="480">
    <v-form ref="form1">
      <v-container grid-list-sm text-center>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-title>
            <v-layout row wrap>
              <v-flex>
                <h3 class="overline">{{ titulo }}</h3>
                <p class="caption font-weight-light">{{ comprobante }}</p>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex>
                <SelectTarjeta
                  :model="itemActivo.Id_Tarjeta"
                  :rules="[rules.requerido]"
                  @seleccionarItem="seleccionarTarjeta"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-text-field
                  ref="controlFocoLote"
                  label="Lote*"
                  v-model="itemActivo.Lote"
                  v-mask="'########'"
                  :rules="[rules.requerido]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  label="Cupón*"
                  v-model="itemActivo.NumeroCupon"
                  v-mask="'########'"
                  :rules="[rules.requerido]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  label="Autorización*"
                  v-model="itemActivo.Autorizacion"
                  v-mask="'########'"
                  :rules="[rules.requerido]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 offset-xs6 md4 offset-md8>
                <Importe2
                  refocus="controlFocoImporte"
                  label="Importe*"
                  v-model="itemActivo.Importe"
                  :rules="[rules.requerido]"
                  @seleccionarItem="seleccionarImporte"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small @click="ejecutarAccion('Cerrar')">
              Cancelar
              <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn color="primary" small @click="ejecutarAccion('Aceptar')">
              Aceptar
              <v-icon right>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-form>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/main";
import SelectTarjeta from "@/components/Tarjeta/SelectTarjeta";
import Importe2 from "@/components/Importe2";
export default {
  name: "ModalTipoPagoTarjeta",
  components: {
    SelectTarjeta,
    Importe2
  },
  props: {
    activo: Boolean,
    comprobante: String,
    importe: Number
  },
  data() {
    return {
      titulo: "Pago con Tarjeta de Débito / Crédito",
      itemVacio: {
        Id_Tarjeta: 0,
        Lote: "",
        NumeroCupon: "",
        Autorizacion: "",
        Importe: 0
      },
      itemActivo: {},
      modalActivo: false,
      rules: {
        requerido: v => !!v || "Requerido"
      }
    };
  },
  watch: {
    activo() {
      this.modalActivo = this.activo;
      if (this.modalActivo) {
        this.itemActivo.Importe = this.importe;
        setTimeout(() => {
          eventBus.$emit("setearFocoSelectTarjeta");
        }, 100);
      } else this.inicializar();
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    seleccionarTarjeta(item) {
      this.itemActivo.Id_Tarjeta = item.Id_Tarjeta;
      this.$refs.controlFocoLote.focus();
    },
    seleccionarImporte() {
      this.ejecutarAccion("Aceptar");
    },
    ejecutarAccion(accion) {
      if (accion == "Aceptar") {
        if (this.$refs.form1.validate()) {
          this.$emit("ejecutarAccion", accion, this.itemActivo);
        }
      } else this.$emit("ejecutarAccion", accion, null);
    }
  }
};
</script>
